// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1ngdV","row":"styles_row__10RYM"};